<script>
    import {PATH_PREFIX} from '../../apiUrls.js';

    import { createEventDispatcher, onMount } from 'svelte';
    import { number, object, string } from 'yup';
    import { submit, validateForm } from '../Form/utils.js';
    import { sgettext } from '../../i18n.js';
    import { debounced } from '../../utils.js';
    import { isAPM } from '../Diff/diffStore.js';

    import {
        activityVersionId,
        readOnly,
        isRequestNumberValid,
        allRequestNumbers
    } from './diffStore.js'

    export let eevId;
    export let governance = null;
    export let governanceUrl = `${PATH_PREFIX}/sw/api/elements_database/governance/elementelementversions/`;

    var saved = false;
    var isValid = false;

    let shape = {
        element_element_version: number().required(sgettext('$$REQUIRED_FIELD$$')),
        activity_version: number().nullable(),
    };

    if (!$isAPM) {
        shape.request_number = number()
          .required(sgettext('$$REQUIRED_FIELD$$'))
          .min(100000000, sgettext("$$MUST_EQUAL_9_DIGITS$$"))
          .max(999999999, sgettext("$$MUST_EQUAL_9_DIGITS$$"));
    }

    const governanceSchema = object().shape(shape);

    var default_gov = {
            request_number: "",
            element_element_version: eevId,
            activity_version: $activityVersionId,
        };

    governance = governance == null ? default_gov : governance;

    const dispatcher = createEventDispatcher();

    const handleSave = debounced(1000, () => {
        saveDetails();
    });

    async function create() {
        const governanceDetail = await submit(governanceUrl, 'POST', governance);
        governance = await governanceDetail;
    }

    async function saveDetails() {
        saved = true;
        try {
            const validation = await validateForm(governanceSchema, governance);
            if ('id' in governance) {
                // If governance set in element promotion, governance object will have a null activity_version so
                // if input event registered perform a create instead of updating the existing governance details.
                if (governance.activity_version != null) {
                    const resp = await submit(`${governanceUrl}${governance.id}/`, 'PUT', governance);
                } else {
                    governance.activity_version = $activityVersionId;
                    await create();
                }
            } else {
                await create();
            }
            isValid = true;
        } catch(err) {
            console.log(err);
            isValid = false;
        }
        dispatcher('handleChange');

      // Only set isRequestNumberValid to true if all fields are valid
      try {
        for (const requestNumber of $allRequestNumbers) {
          await validateForm(governanceSchema, requestNumber);
        }
        isRequestNumberValid.set(true);
      } catch {
        isRequestNumberValid.set(false)
      }

    }

    onMount(async () => {
      // Only set isRequestNumberValid to true if all fields are valid
      $allRequestNumbers.push(governance)
      try {
        for (const requestNumber of $allRequestNumbers) {
          await validateForm(governanceSchema, requestNumber);
        }
        isRequestNumberValid.set(true);
      } catch {
        isRequestNumberValid.set(false)
      }

      try {
          const validation = await validateForm(governanceSchema, governance);
          isValid = true;
      } catch(err) {
          isValid = false;
      }
    });
</script>

<input
  class="form-control form-control-sm {!isValid
    ? 'is-invalid'
    : saved
    ? 'is-valid'
    : ''}"
  style="margin-bottom: 4px; height: 1.75em;"
  placeholder={sgettext('$$REQUEST$$')}
  type="number"
  disabled={$readOnly}
  on:input={handleSave}
  bind:value={governance.request_number}
  tabindex="0"
  title={sgettext("$$MUST_EQUAL_9_DIGITS$$")}
/>
